export function removeDomainForInternalRoute(urlString) {
    const splitOnHash = urlString.split("#/");
    if(splitOnHash.length === 2)
        return `/${splitOnHash[1]}`;

    return urlString;
}